<div class="row">
  <div class="col-sm-12">
<div class="card">
  

  <div class="card-body" id="site_tabular" style="padding-top: 14px;">
    <div class="header" style="display: flex;justify-content: space-between;align-items: center;">
      <div class="d-flex justify-content-start align-items-center " style="font-weight: 600;font-size: 18px;">{{TableHeader}}
        <span *ngIf="loader" style="position: relative; left: 10px">
          <svg style="height:27px;width:28px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><circle fill="#d91e47" stroke="#d91e47" stroke-width="15" r="15" cx="40" cy="65"><animate attributeName="cy" calcMode="spline" dur="2" values="65;135;65;" keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite" begin="-.4"></animate></circle><circle fill="#d91e47" stroke="#d91e47" stroke-width="15" r="15" cx="100" cy="65"><animate attributeName="cy" calcMode="spline" dur="2" values="65;135;65;" keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite" begin="-.2"></animate></circle><circle fill="#d91e47" stroke="#d91e47" stroke-width="15" r="15" cx="160" cy="65"><animate attributeName="cy" calcMode="spline" dur="2" values="65;135;65;" keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite" begin="0"></animate></circle></svg>
        </span>
      </div>
      <div class="header-actions-wrapper">
        <div class="header-actions">
        
        <!-- Show as tags if screen is more than 600px -->
        <ng-container *ngIf="!isMobileView && ExportFileName === 'Site Data'">
          <ng-container *ngFor="let filter of filterConfig">
            <div
              class="filter-active"
              *ngIf="statusMap[filter.key] === 'active'"
              [ngStyle]="{ 'animation-delay': (filter.key.length * 50) + 'ms' }"
              (click)="updateStatus(filter.key)">
              <span>{{ filter.label }}</span>
              <img class="ximage" src="assets/DashboardIcon/x-primary.svg" alt="">
            </div>
          </ng-container>
        </ng-container>
        
        <!-- Show dropdown if screen is 600px or less -->
        <ng-container *ngIf="isMobileView && !isSearchOpen && ExportFileName === 'Site Data'">
          <div class="filter-dropdown-container">
            <div 
              class="filter-dropdown-toggle" 
              (click)="toggleDropdown()"
              [class.active]="isOpen">
              <span class="filter-count">{{ activeFiltersCount }}</span>
            </div>
            
            <div class="filter-dropdown-content" [class.show]="isOpen">
              <div class="filter-items">
                <ng-container *ngFor="let filter of filterConfig">
                  <div
                    class="filter-active-item"
                    *ngIf="statusMap[filter.key] === 'active'"
                    [ngStyle]="{ 'animation-delay': (filter.key.length * 50) + 'ms' }"
                    (click)="updateStatus(filter.key)">
                    <span>{{ filter.label }}</span>
                    <img class="ximage" src="assets/DashboardIcon/x-primary.svg" alt="remove filter">
                  </div>
                </ng-container>
        
                <div class="no-filters" *ngIf="activeFiltersCount === 0">
                  <span>
                    No active filters
                  </span>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <div *ngIf="ShowDLFilter === true"> 
          <!-- Not showing this Incase Coming from service provider with command for DLList data and See Service Poriders and Status -->
          @for(outlineitem of CustomOutlineData; track outlineitem){
            <div class="btn-group btn-group-pill">
              @for(buttonsitem of outlineitem.item; track buttonsitem) {
                <button
                  style="padding: 0.2rem 0.75rem !important;"
                  class="btn {{buttonsitem.class}}"
                  [ngClass]="{'active': selectedKey === buttonsitem.key}"
                  type="button"
                  (click)="SelectDataloggerData(buttonsitem.key)">
                  {{buttonsitem.text}}
                </button>
              }
            </div>
          }
        </div>
        <div *ngIf="!pageNation" class="search-container" ngbTooltip = 'Search' placement = 'top'>
          <input type="text"       
          class="search-bar form-control" 
          [class.open]="isSearchOpen"
          id="filter-text-box" placeholder="Filter..." #filterTextBox  (input)="onFilterTextBoxChanged()" />    
                  <button class="tablebtns" (click)="toggleSearch()">
            <img height="24" width="24" src="assets/images/Icons/Search.png" alt="Search">
          </button>
        </div>  
        <div class="columnsearchfilter" ngbTooltip = 'Column Search Filter' placement = 'top' *ngIf="!pageNation">
          <button  class="tablebtns"  (click)="toggleFloatingFilter()" >
        <img height="24" width="24" [src]="filterIcon" alt="Filter records">
      
          </button>
        </div>
        <div class="ColumnFilters" ngbTooltip = 'Column Filter' placement = 'top'>
          <button   class="tablebtns" (click)="toggleColumnMenu($event)">
            <img height="24" width="24" src="assets/images/Icons/SideColumns.png"  alt="SideColumns">
          </button>
  
        </div>
  
        <div *ngIf="csv" ngbTooltip = 'Download CSV' placement = 'top' style="display: flex;">
          <button  class="tablebtns" style="line-height: 0 !important;" (click)="onExport('CSV')">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M480.9 152.2c0-2.9-1.3-5.7-3.5-7.6L309 2.4C307.2.8 305 0 302.6 0H120.9C97.7.1 79 19 79 42.2V252H58.3c-15.5 0-28.1 10.6-28.1 23.6v120.3c0 13 12.6 23.6 28.1 23.6H79V470c0 23 18.7 41.9 41.9 42h319c23.2-.1 41.9-19 41.8-42.2zM301.8 11l168.6 141H304.6c-2.9 0-3.3-3.3-3.3-3.3zM58.3 409.4c-8.9 0-16.2-6.1-16.2-13.6V275.6c0-7.5 7.2-13.6 16.2-13.6h318.5c8.9 0 16.2 6.1 16.2 13.6v120.3c0 7.5-7.2 13.6-16.2 13.6H58.3zM439.9 502h-319c-17.7-.1-31.9-14.5-31.8-32.1v-50.5h287.8c15.5 0 28.1-10.6 28.1-23.6V275.6c0-13-12.6-23.6-28.1-23.6H89V42.2c0-17.7 14.2-32.1 31.9-32.2h171c0 .3-.1.6-.1 1l-.5 137.6c0 .5 0 1 .1 1.4.9 5.9 5.7 11.9 13.3 11.9h166.4l.8 307.9c-.1 17.7-14.3 32.1-32 32.2z" fill="#174261" opacity="1" data-original="#000000" class=""></path><path d="m154 342 19.8 6c-1.1 5-3.2 9.8-6.3 13.9-2.8 3.7-6.4 6.5-10.6 8.4s-9.6 2.8-16.2 2.8c-7.9 0-14.4-1.2-19.4-3.5s-9.4-6.4-13-12.2-5.5-13.2-5.5-22.3c0-12.1 3.2-21.4 9.6-27.8 6.4-6.5 15.5-9.7 27.3-9.7 9.2 0 16.4 1.9 21.7 5.6s9.2 9.4 11.7 17.1l-19.9 4.4c-.5-1.7-1.2-3.4-2.2-4.9-1.2-1.7-2.8-3.1-4.6-4-6.3-3-13.9-1-17.9 4.8-2.1 3-3.1 7.8-3.1 14.4 0 8.1 1.2 13.6 3.7 16.6s5.9 4.5 10.4 4.5c4.3 0 7.6-1.2 9.8-3.6s3.7-5.9 4.7-10.5zM180.8 347.7l21.5-1.3c.2 2.9 1.2 5.6 2.8 8 2.3 2.9 5.7 4.4 10 4.4 3.2 0 5.7-.8 7.4-2.3 1.6-1.3 2.6-3.2 2.6-5.3 0-2-1-3.8-2.5-5.1-1.7-1.5-5.6-2.9-11.6-4.2-9.9-2.2-16.9-5.2-21.2-8.9-4.2-3.5-6.5-8.7-6.4-14.1 0-3.8 1.1-7.5 3.3-10.6 2.4-3.5 5.8-6.3 9.8-7.9 4.4-1.9 10.3-2.9 17.9-2.9 9.3 0 16.4 1.7 21.3 5.2s7.8 9 8.7 16.5l-21.3 1.3c-.6-3.3-1.7-5.7-3.6-7.2-1.8-1.5-4.3-2.2-7.5-2.2-2.6 0-4.6.5-5.9 1.7-1.3 1-2 2.5-2 4.1 0 1.2.6 2.4 1.6 3.1 1.1 1 3.6 1.9 7.6 2.7 9.9 2.1 16.9 4.3 21.2 6.5 3.8 1.8 7 4.6 9.3 8.1 2 3.3 3 7 2.9 10.8 0 4.6-1.3 9.1-3.9 13-2.7 4-6.4 7.1-10.9 9-4.7 2-10.5 3.1-17.6 3.1-12.4 0-21-2.4-25.8-7.2-4.5-4.9-7.4-11.4-7.7-18.3zM251.1 298.9h23.6l16.4 52.5 16.2-52.5h22.9l-27.1 73h-24.4z" fill="#174261" opacity="1" data-original="#000000" class=""></path></g>
            </svg>
          </button>
        </div>

        <div *ngIf="pageNation && pdf" ngbTooltip = 'Download PDF' placement = 'top' style="display: flex;">
          <button  class="tablebtns" style="line-height: 0 !important;" (click)="onExport('PDF')">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M494.479 138.557 364.04 3.018A9.853 9.853 0 0 0 356.945 0h-194.41c-21.757 0-39.458 17.694-39.458 39.442v137.789H44.29c-16.278 0-29.521 13.239-29.521 29.513v147.744C14.769 370.761 28.012 384 44.29 384h78.787v88.627c0 21.71 17.701 39.373 39.458 39.373h295.238c21.757 0 39.458-17.653 39.458-39.351V145.385a9.85 9.85 0 0 0-2.752-6.828zM359.385 26.581l107.079 111.265H359.385V26.581zM44.29 364.308c-5.42 0-9.828-4.405-9.828-9.82V206.744c0-5.415 4.409-9.821 9.828-9.821h265.882c5.42 0 9.828 4.406 9.828 9.821v147.744c0 5.415-4.409 9.82-9.828 9.82H44.29zm433.248 108.341c0 10.84-8.867 19.659-19.766 19.659H162.535c-10.899 0-19.766-8.828-19.766-19.68V384h167.403c16.278 0 29.521-13.239 29.521-29.512V206.744c0-16.274-13.243-29.513-29.521-29.513H142.769V39.442c0-10.891 8.867-19.75 19.766-19.75h177.157v128c0 5.438 4.409 9.846 9.846 9.846h128v315.111z" fill="#174261" opacity="1" data-original="#000000" class=""></path><path d="M132.481 249.894c-3.269-4.25-7.327-7.01-12.173-8.279-3.154-.846-9.923-1.269-20.308-1.269H72.596v84.577h17.077v-31.904h11.135c7.731 0 13.635-.404 17.712-1.212 3-.654 5.952-1.99 8.856-4.01 2.904-2.019 5.298-4.798 7.183-8.336 1.885-3.538 2.827-7.904 2.827-13.096-.001-6.731-1.636-12.221-4.905-16.471zm-14.625 23.279c-1.288 1.885-3.067 3.269-5.337 4.154s-6.769 1.327-13.5 1.327h-9.346v-24h8.25c6.154 0 10.25.192 12.288.577 2.769.5 5.058 1.75 6.865 3.75 1.808 2 2.712 4.539 2.712 7.615.001 2.5-.644 4.692-1.932 6.577zM219.481 263.452c-1.846-5.404-4.539-9.971-8.077-13.702s-7.789-6.327-12.75-7.789c-3.692-1.077-9.058-1.615-16.096-1.615h-31.212v84.577h32.135c6.308 0 11.346-.596 15.115-1.789 5.039-1.615 9.039-3.865 12-6.75 3.923-3.808 6.942-8.788 9.058-14.942 1.731-5.039 2.596-11.039 2.596-18 0-7.923-.923-14.586-2.769-19.99zm-16.616 34.731c-1.154 3.789-2.644 6.51-4.471 8.163-1.827 1.654-4.125 2.827-6.894 3.519-2.115.539-5.558.808-10.327.808h-12.75v-56.019h7.673c6.961 0 11.635.269 14.019.808 3.192.692 5.827 2.019 7.904 3.981 2.077 1.962 3.692 4.692 4.846 8.192s1.731 8.519 1.731 15.058c0 6.538-.577 11.701-1.731 15.49zM294.827 254.654v-14.308h-57.981v84.577h17.077v-35.942h35.308v-14.308h-35.308v-20.019z" fill="#174261" opacity="1" data-original="#000000" class=""></path></g></svg>
          </button>
        </div>
        <div *ngIf="displayAddbutton && add_edit" class="siteaddBtn btn" [routerLink]="'/addsites'">Add Site</div>

        <div *ngIf="addApplication == true"  placement = 'top'>
          <button *ngIf="addRouteUrl; else addModalButton" class="add-application" (click)="addRouteRequested.emit()">
                +Add {{buttonTitle}}
          </button>
          <ng-template #addModalButton>
          <button class="add-application" data-bs-toggle="modal" [attr.data-bs-target]="'#' + modalId">
                +Add {{buttonTitle}}
          </button>
          </ng-template>
        </div>
        <div class="btn-group "  *ngIf="SiteDropDown == true" placement="top">
          <div class="btn-group" ngbDropdown style="position: relative;">
              <div>
                <input
                ngbDropdownToggle
                type="text"
                class="form-control"
                id="selectsitebulk"
                [(ngModel)]="searchTerm"
                placeholder="Select site..."
                (input)="onInputChange($event)"
                (click)="$event.stopPropagation()"
                style="background: #F5F5F5;border: none;height: 33px;border-radius: 12px;"/>
                <i class="fa fa-angle-down" style="margin-top: -23px;position: absolute;z-index: 27;margin-left: 110px;"></i>
              </div>
              <ul ngbDropdownMenu class="dropdown-menu">
                <div class="scroll" style="overflow-y: auto; max-height: 250px;">
                    <li *ngIf="!internalOptions.length"
                      class="dropdownItems text-muted px-2 py-1">
                      No sites available
                    </li>
                    <li *ngFor="let site of filteredItems"
                    ngbDropdownItem
                    style="cursor: pointer;"
                    (click)="selectOption(site)">
                    {{ site.site_name }}
                    </li>
                </div>
              </ul>
          </div>
        </div>

        <div *ngIf="AddBulkaction == true"  placement = 'top'>
          <button  class="add-application" (click)="CreateBulkAction()">
                + Create New Bulk
          </button>
        </div>
        <div class="date-range-wrapper" *ngIf="DateFilterShow && !isMobileView">
            <input
              class="form-control datepicker"
              type="text"
              [placeholder]="placeholder"
              mwlFlatpickr
              [disableMobile]="true"
              
              [maxDate]="today"
              [altInput]="true"
              [altFormat]="altFormat"
              [dateFormat]="dateFormat"
              [mode]="rangeMode"
              [plugins]="plugins"
              [(ngModel)]="dateRange"
              (ngModelChange)="updateFormattedDates()"/>
            <img src="assets/DashboardIcon/calendar-icon.svg" class="calendar-icon" alt="Calendar Icon" (click)="openCalendar()"/>
        </div>
      </div>
      </div>

    </div>
    <div class="date-range-wrapper mobile-view" *ngIf="DateFilterShow && isMobileView">
        <input
          class="form-control datepicker"
          type="text"
          [placeholder]="placeholder"
          mwlFlatpickr
          [disableMobile]="true"
          [altInput]="true"
          [altFormat]="altFormat"
          [dateFormat]="dateFormat"
          [mode]="rangeMode"
          [plugins]="plugins"
          [(ngModel)]="dateRange"
          (ngModelChange)="updateFormattedDates()"/>
        <img src="assets/DashboardIcon/calendar-icon.svg" class="calendar-icon" alt="Calendar Icon" />
    </div>

    <div *ngIf="showColumnMenu" class="column-menu-wrapper" >
      <div class="column-visibility-menu card">
        <div class="menu-header">
          <button class="" (click)="hideAll()" [disabled]="isHideAllDisabled" ><p>Hide all</p></button>
          <button (click)="showAll()" [disabled]="isShowAllDisabled"><p>Show all</p></button>
        </div>
        <div class="menu-body">
          
          <p class="menu-item" *ngFor="let colDef of columnDefs">
            <label class="switch">
              <input type="checkbox" [checked]="!colDef.hide" (change)="toggleColumnVisibility(colDef)">
              <span class="slider round"></span>
            </label>
            <span>
              {{ colDef.headerName }}          
            </span>
          </p>
        </div>
      </div>
    </div>  
  <div>
    <ag-grid-angular
        style="width: 100%; height: 500px;"
        class="ag-theme-quartz"
        [suppressColumnVirtualisation]="true"
        [rowData]="rowData"
        [gridOptions]="gridOptions"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [autoSizeStrategy]="autoSizeStrategy"
        [pagination]="true"
        [paginationPageSizeSelector]="paginationPageSizeSelector"
        enableCellTextSelection="true"
        [enableCellSpan]="true"
        [paginationPageSize]="10"
        (gridReady)="onGridReady($event)"
        (paginationChanged)="onPaginationChanged($event)"
        theme="legacy"
        [rowSelection]="rowSelection"
    
        [pinnedBottomRowData]="pinnedBottomRowData" 
    
        >
    </ag-grid-angular>
  </div>

</div>
</div>
</div>
</div>

<app-form-modal
  [FormArray]="columnFormFields"
  [Multiplefields]="true"
  [rowData]="columnFormRow"
  modalId="columnFormModal"
  [Modaltitle]="columnFormTitle"
  [header]="columnFormTitle"
  leftButtonTitle="Cancel"
  rightButtonTitle="Submit"
  (fomrresponse)="onColumnFormResponse($event)"
></app-form-modal>
